import { EssayAnswerSchema, TestQuestionType } from '../Types/TestQuestion';

type TestQuestionItem = {
	type: TestQuestionType;
	title: string;
};
type AnswerSchemaType = {
	type: EssayAnswerSchema;
	title: string;
};

export const TestQuestions: Array<TestQuestionItem> = [
	{ type: 'mcq', title: 'Multiple Choice' },
	// The /mrq route exists and the backend grades the type, but nothing led
	// here — so an instructor could edit an mrq question and never create one.
	// The admin app offers the same choice as a Single/Multiple switch on the
	// create form instead; this app's form has no such control.
	{ type: 'mrq', title: 'Multiple Response' },
	{ type: 'gap', title: 'Fill the gap' },
	{ type: 'ordering', title: 'Ordering' },
	{ type: 'essay', title: 'Essay' },
	// { type: 'matching', title: 'Matching' },
	// { type: 'dragAndDrop', title: 'Drag-and-drop' },
];

export const AnswerSchema: Array<AnswerSchemaType> = [
	{ type: 'text', title: 'Text' },
	{ type: 'attachment', title: 'Attachment' },
	{ type: '*', title: 'Both' },
];
